import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { hasGlobalFeature } from 'selectors';
import { routes } from 'constants/config';
import Layout from '../shared/Layout';
import Loading from '../shared/Loading';
import Sidebar from './Sidebar';
import Assignments from './Assignments';
import MyContent from './MyContent';
import Topic from './Topic';
import History from './History';

const Content = ({ hasFeatureChangeAssignmentsToResources }) => (
  <Layout.Main>
    <Loading>
      <Layout.Side>
        <Sidebar />
      </Layout.Side>
      <Layout.Content>
        <Switch>
          <Route
            path={
              hasFeatureChangeAssignmentsToResources
                ? routes.LEARN_RESOURCES
                : routes.LEARN_ASSIGNMENTS
            }
            component={Assignments}
          />
          <Route path={routes.LEARN_TOPIC} component={Topic} />
          <Route path={routes.LEARN_HISTORY} component={History} />
          <Route component={MyContent} />
        </Switch>
      </Layout.Content>
    </Loading>
  </Layout.Main>
);

const mapStateToProps = state => ({
  hasFeatureChangeAssignmentsToResources: hasGlobalFeature(
    state,
    'change_assignments_to_resources',
  ),
});

export default connect(mapStateToProps)(Content);
